import { gql } from '@apollo/client';

export default gql`
  fragment PaymentsFee on Fee {
    itemRef
    price: priceWithCurrency
    name
    code
    currency
    cancelled
  }
`;
